import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ScrollView, Linking,
	Dimensions, FlatList, AsyncStorage, ActivityIndicator, I18nManager, Platform } from "react-native";

import { format, parse } from 'date-fns'

import * as Font from 'expo-font';
import { payment } from "../config/payment"
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import Main from "../widgets/Main";
import * as firebase from "firebase";
import MainComponent from "../utilities/MainComponent";
import i18n from 'i18n-js';
import Axios from 'axios'
import * as WebBrowser from 'expo-web-browser';
import AppContext, {AppProvider} from "../utilities/AppContext"
import { da } from "date-fns/locale";

export default class ConfirmScreen extends MainComponent {	

	state = {
		data : {
			totalPrice : 0,
			promoDiscount: 0
		},
		promoDiscount : 0,
		deliveryCharges : 0,
		status: false,
		taxCharges : 0,
		totalPrice : 0,
		deliveryData: {area: {name: ""}},
		userData : [],
		store: {currency: ""},
		orderData: [],
		showFullMode 	: true,
		isLoading: false,
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		this.state.showError = false
	
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
		this.state.totalPrice = 0
		this.state.taxCharges = 0
		this.state.deliveryCharges = 0

		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.state.onUpdate = this.context.onUpdate;
		this.getDetails()
	}

	getDetails = async () => {		
		
		await Font.loadAsync(color.appFonts);

		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
			this.setState({store: value})     
			
			if(value.status == false)
				this.props.navigation.navigate("menu");

        } catch (error) {
            console.log(error)
		}
	
		try {
			var value = await AsyncStorage.getItem(store.key)
			var orderData = JSON.parse(value)			

		 	var deliveryData = await AsyncStorage.getItem(store.delivery)
			deliveryData = JSON.parse(deliveryData)			

		 	value = await AsyncStorage.getItem(store.user)
			var userData = JSON.parse(value)

			var promoData = await AsyncStorage.getItem(store.promo)
			if(promoData == undefined || promoData == '' || promoData == 'undefined')
				promoData = undefined
			else
				promoData = JSON.parse(promoData)
			
			if(orderData.length <= 0)
				this.props.navigation.navigate("menu");

			// Tax CHARGES
			this.state.deliveryData = deliveryData
			this.state.userData   = userData
			this.state.orderData  = orderData
			this.state.promoData  = promoData

			this.createRequest()		
			
		} catch (error) {
			this.setState({isLoading: false})
			console.log(error);			
		}
	}

	createRequest()
	{
		const {mainTotalPrice, itemsPrice, taxCharges, deliveryCharges, ordersData, promoDiscount, offersDiscount} = this.calculateTotalOrderPrice(
			this.state.orderData, this.state.store, this.state.deliveryData, this.state.promoData
		)					

		var mainData = []
		ordersData.forEach(mData => {
			var val = JSON.parse(JSON.stringify(mData))
			delete val.mainItem
			mainData.push(val)
		})

		let ref = firebase.database().ref('orders').push()	
		var data = {
			offersDiscount  : offersDiscount,
			payType			: this.state.userData.paymentType,
			orderData 		: mainData,
			promoData 		: this.state.promoData == undefined ? [] : this.state.promoData,
			deliveryData 	: this.state.deliveryData,
			userData 		: this.state.userData,
			key 			: ref.key,
			promoDiscount	: promoDiscount,
			taxCharges		: taxCharges,
			deliveryCharges : deliveryCharges,
			itemsPrice		: itemsPrice,
			totalPrice 		: mainTotalPrice,
			storeId : store.storeId,
			currency: this.state.store.currency,
			status 	: 0,
			store : {name: store.name, storeId: store.storeId, logoUrl: this.state.store.logoUrl},
			orderId : this.state.store.orderPrefix + (new Date().getTime()).toString().slice(-6),
			timestamp : firebase.database.ServerValue.TIMESTAMP
		}

		this.state.data = data	
		this.setState({offersDiscount: offersDiscount, promoDiscount : promoDiscount, taxCharges: taxCharges, isLoading: false, deliveryData: this.state.deliveryData, deliveryCharges: deliveryCharges, totalPrice: mainTotalPrice})				
		
		this.callPixelEvent("Initiate checkout", ref.key)

		/*
		if(this.state.data.userData.paymentType == payment.PAY_BY_CASH){
			//this.finalizeOrder(updates, data)
		}else{
			this.initializePayment()
		}*/
	}

	backBtnPressed(){
		if(!this.state.isLoading)
			this.props.navigation.goBack(null)
	}

	openArea(){
		this.context.onUpdate = this.onSelectArea.bind(this)
		this.props.navigation.navigate('area');
	}

	changeLocation(){
		this.context.onUpdate = this.saveLocation.bind(this)
		this.props.navigation.navigate('delivery');
	}

	saveLocation = async data => {
		this.setState({address: data});
		//await AsyncStorage.setItem(store.delivery, JSON.stringify(deliveryData))
	};

	onSelectArea = async data => {
		let deliveryData = {area: data.data, timings: this.state.deliveryData.timings}
		this.setState({deliveryData: deliveryData});
		await AsyncStorage.setItem(store.delivery, JSON.stringify(deliveryData))
	};

	onSubmit = async () => {	
			
		if(this.state.isLoading)
			return;

		if(this.state.promoData != undefined)
			this.applyPromo()
		else{
			this.setState({isLoading: true})
			this.finalizeOrder()
		}
	}

	applyPromo(){

		this.setState({isLoading: true})
		firebase.database().ref('promotions/' + store.storeId).orderByChild("promoCode").equalTo(this.state.promoData.promoCode).limitToFirst(1).once("value", function(snapshot) {

			let mData = snapshot.val()
			if (mData == undefined){
				this.state.promoData = undefined
				this.setState({promoData: undefined})
				this.createRequest()
			}else{
			
				let promoData = Object.keys(mData).map(function(key) {
					mData[key].key = key;
					return mData[key];
				})

				if(promoData.length > 0)
				{
					mData = promoData[0]
					var catDataFound = true
					var prodDataFound = true

					if(mData.productsList != undefined && mData.productsList.length > 0)
					{
						prodDataFound = false
						mData.productsList.forEach(item => 
						{
							this.state.data.orderData.forEach(productItem => 
							{
								if(productItem.key == item.key)
									prodDataFound = true
							})
						})
					}
					
					if(mData.categoriesList != undefined && mData.categoriesList.length > 0)
					{
						catDataFound = false
						mData.categoriesList.forEach(item => 
							{
								this.state.data.orderData.forEach(productItem => 
								{
									if(productItem.categoryId == item.key)
										catDataFound = true
								})
							})
					}
				
					let usageCount = mData.usageLimit - mData.usageCount
						// Need to check if it fulfills the conditions.
					let startDate 	  = (mData.startDate == undefined || mData.startDate == "") ? new Date().getTime() : mData.startDate
					let currentDate   = new Date().getTime()
					let endDate   	  = (mData.endDate == undefined || mData.startDate == "") ? new Date().getTime() : mData.endDate
						
					if (mData.status == true && usageCount > 0 
						&& mData.minimumPurchase <= this.state.totalPrice
						&& currentDate >= startDate
						&& currentDate <= endDate	
						&& (catDataFound || prodDataFound)	 			
						)
					{
						// Promotion still valid
						this.finalizeOrder()
					}
					else{
						this.state.promoData = undefined
						this.setState({promoData: undefined})
						this.createRequest()		
					}
				}else{
					this.state.promoData = undefined
					this.setState({promoData: undefined})
					this.createRequest()	
				}
			}
		}.bind(this), function(error) { 
			console.log(error)
			this.state.promoData = undefined
			this.setState({promoData: undefined})
			this.createRequest()
		});
	}

	finalizeOrder()
	{
		var that = this;

		var updates = {}	
		updates['/temp/' 	  + this.state.data.key] = this.state.data
		firebase.database().ref().update(updates).then(function(snapshot) 
		{							
			if(that.state.data.userData.paymentType == payment.PAY_BY_CASH){
				that.finalizeCashPayment()				
			}else{		
				that.initializePayment()
			}
		}).catch(error => {
			that.setState({isLoading: false})
			console.log(error);
			alert('Sorry, An unknown error has occurred');
		});
	}

	async finalizeCashPayment()
	{
		let options = {
			//url: payment.testFinalCashUrl,
			url: payment.finalCashUrl,
			method: 'POST',
			data: {
				storeId : store.storeId,
				orderKey : this.state.data.key
			}
		};

		let response = await Axios(options)
		if(response != undefined && response.status == 200)
		{
			if(response.data.error == false){
				Linking.canOpenURL(response.data.callback)
				.then((supported) => {
					if (supported) {
						return Linking.openURL(response.data.callback)
							.catch(() => null);
					}
				});
			}	
			else
			{
				if(response.data.message != undefined)
					alert(response.data.message);
				else
					alert('Sorry, An error has occurred. Please try again later');
			}		
		}			

		this.setState({isLoading : false})
	}

	async initializePayment()
	{
		var that = this
		let options = {
			url: payment.createPayment,
			method: 'POST',
			data : this.state.data			
		};
		console.log(options)
		try{
			let response = await Axios(options)
			console.log(response)
			let resp = response.data
			if(resp.error == false)
			{
				Linking.canOpenURL(resp.data)
				.then((supported) => {
					if (supported) {
						return Linking.openURL(resp.data)
							.catch(() => null);
					}
				});
			}
			else
			{
				alert(resp.message)
				that.setState({isLoading: false})
			}
		}catch(e)
		{
			that.setState({isLoading: false})
			console.log(e)
		}			
	}

	renderListItem = ({ item, index }) => 
	{	
		var totalPrice = item.price
		var modifiers = ""	
		if (item.counter == undefined)
			item.counter = 1
		
		item.addons.map(mObj => {
			mObj.modifiers.map(obj => {
				totalPrice += obj.price
				if(modifiers == '')
					modifiers = obj.name
				else
					modifiers = modifiers + ", " + obj.name
			})
		})
	
		totalPrice = totalPrice * item.counter	
		return (
			
			<View  style={{backgroundColor:"white", height: 35, marginLeft: 15, flexDirection: "row", marginRight: 15, justifyContent: "center", alignContent: "center", alignItems: "center"}}>	
				<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 14 }}>{item.counter}x</Text>			
				<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 14, marginLeft: 10 }}>{item.name}</Text>
				{ I18nManager.isRTL && (
					<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 14, marginLeft: "auto", marginRight:0}}>{totalPrice.toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>
				)}
				{ !I18nManager.isRTL && (
					<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 14, marginLeft: "auto", marginRight:0}}>{i18n.t('currency.' + this.state.store.currency.toLowerCase())} {totalPrice.toFixed(3)} </Text>
				)}
			</View>
		);
	}
	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */
	
	// List View 
	renderDetails(){

		var icoName = "ios-arrow-back"
		if(!I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		let height = 2.5
		var paymentType = ""
		if(this.state.userData.paymentType == payment.PAY_BY_KNET)
			paymentType = i18n.t("knet")
		else if(this.state.userData.paymentType == payment.PAY_BY_CASH)
			paymentType = i18n.t("payCash")
		else if(this.state.userData.paymentType == payment.PAY_BY_CARD)
			paymentType = i18n.t("card")

		var timings = ""
		if(this.state.deliveryData != undefined && this.state.deliveryData.timings != undefined && this.state.deliveryData.timings != "")
		{
			try{
				timings = format(parse(this.state.deliveryData.timings.date, 'dd-MM-yyyy', new Date()), 'dd MMM') + " " +  this.state.deliveryData.timings.data.openingTime + " - " + this.state.deliveryData.timings.data.closingTime
			}catch{
				timings =  i18n.t(this.state.deliveryData.timings.date, {defaultValue: this.state.deliveryData.timings.date})
			}
		}

		var mainArea = ""
		if(this.state.userData.block != undefined && this.state.userData.block != "")			
			mainArea = i18n.t("block") + " " + this.state.userData.block 
		if(this.state.userData.street != undefined && this.state.userData.street != "")			
			mainArea += " , " + i18n.t("street") + " " + this.state.userData.street 
		if(this.state.userData.avenue != undefined && this.state.userData.avenue != "")			
			mainArea += " , " + i18n.t("avenue") + " " + this.state.userData.avenue 
		if(this.state.userData.building != undefined && this.state.userData.building != "")			
			mainArea += " , " + i18n.t("building") + " " + this.state.userData.building 
		if(this.state.userData.floor != undefined && this.state.userData.floor != "")			
			mainArea += " , " + i18n.t("floor") + " " + this.state.userData.floor 
		if(this.state.userData.house != undefined && this.state.userData.house != "")		
		{	
			if(this.state.userData.unitType == 0)
				mainArea += ", " + i18n.t("house") + " # "
			else if(this.state.userData.unitType == 1)
				mainArea += ", " + i18n.t("office") + " # "
			else if(this.state.userData.unitType == 2)
				mainArea += ", " + i18n.t("appartment") + " # "
			mainArea += this.state.userData.house 
		}
						
		mainArea = mainArea.replace(", ,", "")

			var branchName = ""
			if(this.state.deliveryData != undefined && this.state.deliveryData.branch != undefined)
			{
				branchName = this.state.deliveryData.branch.name + " - " + this.state.deliveryData.branch.address
				if(i18n.locale != this.state.store.defaultLanguage){
					branchName  = this.state.deliveryData.branch.nameSecondary + " - " + this.state.deliveryData.branch.addressSecondary
				}		
			}

			var deliveryChargesText = "-"
			if(this.state.deliveryData.area != undefined && this.state.deliveryData.area.fee != undefined)
			{
				if(I18nManager.isRTL)
					deliveryChargesText = (+this.state.deliveryData.area.fee).toFixed(3) + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
				else
					deliveryChargesText = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + (+this.state.deliveryData.area.fee).toFixed(3)
			}

		if(this.state.promoData != undefined)
		{
			var promoDiscounText = "-"
			if(I18nManager.isRTL)
				promoDiscounText = this.state.data.promoDiscount.toFixed(3) + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				promoDiscounText = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + this.state.data.promoDiscount.toFixed(3)
		}

		var offersDiscount = "-"
		if(this.state.offersDiscount != undefined && this.state.offersDiscount > 0)
		{
			if(I18nManager.isRTL)
				offersDiscount = this.state.offersDiscount.toFixed(3) + " " + i18n.t('currency.' + this.state.store.currency.toLowerCase())
			else
				offersDiscount = i18n.t('currency.' + this.state.store.currency.toLowerCase()) + " " + this.state.offersDiscount.toFixed(3)
		}

		return (

			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>
					<View style={{height: height, flexDirection: "row", marginTop: 50}}>

						<View style={{height: height, width: 5}}/>
						{ this.state.store != undefined  && (	
							<View>		
								<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
								<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
								<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
								<View style={{height: height, flex: 1, borderRadius: 1, marginRight: 5, backgroundColor:this.state.store.primaryColor}}/>
							</View>
						)}	

					</View>
					{ this.state.showError  && (
						<View style={{height: 25, backgroundColor: 'red', justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{ fontFamily: 'main-regular',color:color.details, fontSize:14, color: "white", textAlign: "center"}}>{this.state.errorMessage}</Text>		
						</View>
					)}
					
					<ScrollView style={{flex: 1, backgroundColor:color.bigSeparator, width: "100%"}}>
						
						<View style={{height: 8,backgroundColor:color.bigSeparator}}/>

						<View style={{justifyContent: "center", width: "100%", backgroundColor: 'white'}}>

								<TouchableOpacity style={{marginLeft: 15, marginRight: 15, height: 40}}
													onPress={() => { 
														//this.openOrders()
													}}
								>
									<View style={{flexDirection: "row", flex:1, justifyContent: "center", alignItems:"center", alignItems: "center"}}>
										<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:14, textAlign: "center"}}>{i18n.t("orderItems")}</Text>	
										<Ionicons style={{marginLeft: "auto",}} size={15} color='black' />	
									</View>

								</TouchableOpacity>

								<View style={{flex: 1}}>
									<FlatList
										extraData={this.state}
										data={this.state.orderData}
										renderItem={this.renderListItem}
										keyExtractor={item => item.name}
									/>
								</View>
						</View>

						<View style={{height: 4,backgroundColor:'white'}}/>
						<View style={{height: 8,backgroundColor:color.bigSeparator}}/>

						{ this.state.deliveryData.area != undefined && (
							<View>

								<TouchableOpacity style={{paddingLeft: 15, paddingRight: 15, height: 40, backgroundColor: 'white'}}
													onPress={() => { 
																//this.openOrders() 
															}}
										>
											<View style={{flexDirection: "row", flex:1, justifyContent: "center", alignItems:"center", alignItems: "center"}}>
												<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:14, textAlign: "center"}}>{i18n.t("deliveryInfo")}</Text>	
												<Ionicons style={{marginLeft: "auto",}} size={20} color='black' />	
											</View>

								</TouchableOpacity>

								<View style={{flexDirection: "row", height: 50, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center", backgroundColor: 'white'}} >
									<Ionicons style={{marginRight: 5}} name="ios-calendar" size={20} color='black' />	
									<Text style={{marginLeft: 10, fontFamily: 'main-regular',color: 'black', fontSize:14, textAlign: "center"}}>{timings}</Text>	
								</View>

								<View style={{height: 1,backgroundColor:color.bigSeparator}}/>
								
									<TouchableOpacity style={{flexDirection: "row", height: 75, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center", backgroundColor: 'white'}} 
										onPress={() => {
											this.props.navigation.goBack(null)	
											var mUpdate = this.state.onUpdate	
											if(mUpdate != undefined)										
												mUpdate({ data: 1 })
										}}
									>						
										<Ionicons style={{marginRight: 5}} name="md-business" size={20} color='black' />	
										<View style={{flex: 1, marginLeft: 10, marginRight: 10}} >
												{i18n.locale == "ar" &&(							
												<Text style={{textAlign: "left", fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{this.state.deliveryData.area.nameArabic}</Text>)}	
												{i18n.locale != "ar" &&(							
												<Text style={{textAlign: "left", fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{this.state.deliveryData.area.name}</Text>)}	
												<Text style={{textAlign: "left", fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{mainArea}</Text>	
										</View>
										<Ionicons style={{marginLeft: "auto"}} name={icoName} size={15} color='black' />	
									</TouchableOpacity>

									<View style={{height: 1,backgroundColor:color.bigSeparator}}/>

									<TouchableOpacity style={{backgroundColor: 'white', flexDirection: "row", height: 65, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center"}} 
												onPress={() => {
													this.props.navigation.goBack(null)	
													var mUpdate = this.state.onUpdate										
													mUpdate({ data: 0 })												
												}}
										>

										<Ionicons style={{marginRight: 5}} name="md-locate" size={20} color='black' />	
										<View style={{marginLeft: 10}} >
												<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{this.state.userData.name}</Text>	
												<Text style={{fontFamily: 'main-regular',color: 'black', fontSize:14, }}>{this.state.userData.phone}</Text>	
										</View>
										<Ionicons style={{marginLeft: "auto"}} name={icoName} size={15} color='black' />	
									</TouchableOpacity>	
							</View>
						)}

						{ this.state.deliveryData.branch != undefined && (
							<View>

								<TouchableOpacity style={{paddingLeft: 15, paddingRight: 15, height: 40, backgroundColor: 'white'}}
													onPress={() => { 
																//this.openOrders() 
																this.handlePressButtonAsync()
															}}
										>
											<View style={{flexDirection: "row", flex:1, justifyContent: "center", alignItems:"center", alignItems: "center"}}>
												<Text style={{fontFamily: 'main-bold', color: 'black', fontSize:14, textAlign: "center"}}>{i18n.t("pickup")}</Text>	
												<Ionicons style={{marginLeft: "auto",}} size={20} color='black' />	
											</View>

								</TouchableOpacity>

								<View style={{flexDirection: "row", height: 50, paddingLeft: 15, paddingRight: 15, alignItems:"center", alignItems: "center", backgroundColor: 'white'}} >
									<Ionicons style={{marginRight: 5}} name="ios-calendar" size={20} color='black' />	
									<Text style={{marginLeft: 10, fontFamily: 'main-regular',color: 'black', fontSize:14, textAlign: "center"}}>{branchName}</Text>	
								</View>

							</View>
						)}

						<View style={{height: 8,backgroundColor:color.bigSeparator}}/>	

								<Text style={{textAlign:"left", paddingTop: 10, paddingLeft: 15, fontFamily: 'main-bold', color: 'black', fontSize:14, backgroundColor: 'white'}}>{i18n.t("paymentMethod")}</Text>	
						<TouchableOpacity style={{paddingLeft: 15, paddingRight: 15, height: 40, paddingTop: 10, backgroundColor: 'white'}}
													onPress={() => { 
														this.props.navigation.goBack(null)	
														this.props.navigation.state.params.onSelectIndex({ data: 2 });												
													}}
								>
									<View style={{flexDirection: "row", flex:1, justifyContent: "center", alignItems:"center", alignItems: "center"}}>
										<Text style={{fontFamily: 'main-regular', color: 'black', fontSize:14, textAlign: "center"}}>{paymentType}</Text>	
										<Ionicons style={{marginLeft: "auto"}} name={icoName} size={15} color='black' />	
									</View>

						</TouchableOpacity>

						<View style={{height: 8,backgroundColor:'white'}}/>		
						<View style={{height: 10,backgroundColor:color.bigSeparator}}/>		

						<View style={{height: 15,backgroundColor:'white'}}/>		
							<View style={{flex: 1, flexDirection: "row", paddingLeft: 15, paddingRight: 15, backgroundColor: 'white'}}>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12}}>{i18n.t("delivery")}</Text>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12, marginLeft: "auto"}}>{deliveryChargesText}</Text>
							<View style={{height: 10,backgroundColor:'white'}}/>		
						</View>

						<View style={{height: 15,backgroundColor:'white'}}/>		
							<View style={{flex: 1, flexDirection: "row", paddingLeft: 15, paddingRight: 15, backgroundColor: 'white'}}>
							<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12}}>{i18n.t("tax")}</Text>
							{ I18nManager.isRTL && (
								<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12, marginLeft: "auto"}}>{this.state.taxCharges.toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>
							)}
							{ !I18nManager.isRTL && (
								<Text style={{ fontFamily: 'main-regular', color: color.detailsColor, fontSize: 12, marginLeft: "auto"}}>{i18n.t('currency.' + this.state.store.currency.toLowerCase())} {this.state.taxCharges.toFixed(3)}</Text>
							)}
							<View style={{height: 10,backgroundColor:'white'}}/>		
						</View>

						{ this.state.promoData != undefined && (
						<View style={{flex: 1, flexDirection: "row", backgroundColor: 'white', paddingRight: 15, paddingLeft: 15, paddingTop: 15}}>
							<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 15, fontWeight:"bold"}}>{i18n.t("promoDiscount")}</Text>
							<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 15, fontWeight:"bold", marginLeft: "auto"}}>- {promoDiscounText}</Text>
						</View>
						)}
						{ this.state.offersDiscount != undefined && this.state.offersDiscount > 0 && (
						<View style={{flex: 1, flexDirection: "row", backgroundColor: 'white', paddingRight: 15, paddingLeft: 15, paddingTop: 15}}>
							<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 15, fontWeight:"bold"}}>{i18n.t("offersDiscount")}</Text>
							<Text style={{ fontFamily: 'main-regular', color: this.state.store.primaryColor, fontSize: 15, fontWeight:"bold", marginLeft: "auto"}}>- {offersDiscount}</Text>
						</View>
						)}

						<View style={{flex: 1, flexDirection: "row", paddingRight: 15, paddingLeft: 15, backgroundColor: 'white', paddingTop: 15}}>
							<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold"}}>{i18n.t("total")}</Text>
							{ I18nManager.isRTL && (
								<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold", marginLeft: "auto", height: 45}}>{(this.state.data.totalPrice).toFixed(3)} {i18n.t('currency.' + this.state.store.currency.toLowerCase())}</Text>
							)}
							{ !I18nManager.isRTL && (
								<Text style={{ fontFamily: 'main-regular', color: "black", fontSize: 18, fontWeight:"bold", marginLeft: "auto", height: 45}}>{i18n.t('currency.' + this.state.store.currency.toLowerCase())} {(this.state.data.totalPrice).toFixed(3)}</Text>
							)}
						</View>

						<View style={{height: 15,backgroundColor:'white'}}/>		

					</ScrollView>

					<View style={{height: 65, marginTop: "auto", backgroundColor:"white", justifyContent: "center"}}>
					
						<TouchableOpacity disabled={this.state.isLoading} style={{marginLeft: 10, marginRight: 10, marginBottom: 10, marginTop: "auto", height:48, justifyContent: "center"}}
											onPress={() => { this.onSubmit() }}
									>
						<View style={{justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:store.primaryColor}}>
							
								{ this.state.isLoading  && (
									<ActivityIndicator style={{marginRight: 5}} size="small" color='white' /> 
								)}
								{ !this.state.isLoading  && (
									<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}>{i18n.t("finalize")}</Text>		
								)}
						</View>

						</TouchableOpacity>

					</View>

				</View>
			)}
			</AppContext.Consumer>
		)
	}

	render() {
		var that = this
		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		if(this.state.status){
			this.handlePressButtonAsync()
		}

		return (
			<View style={styles.container}>

				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

	                        {that.renderDetails()}

							<View style={styles.topBar}>															
								<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t("checkout")}</Text>																						
								</View>	
								<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems: "center"}}
										onPress={() => { this.props.navigation.goBack(null) }} >
										<Ionicons name={icoName} size={24} color={'black'} />
								</TouchableOpacity>		
							</View>

						</View>

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
	                        {that.renderDetails()}
						</View>

						<View style={styles.topBar}>	
							<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t("checkout")}</Text>																						
							</View>	
							<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems: "center"}}
									onPress={() => { this.props.navigation.goBack(null) }} >
									<Ionicons name={icoName} size={24} color={'black'} />
							</TouchableOpacity>													
						</View>
						
					</View>
				)}
				
			</View>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});